module.exports = __webpack_public_path__ + "img/TECH_Horizontal_Color.d9f4d7d2.png";